import {SPRITES} from "./sprites";

/**
 * Disposition du fond « Manettes » : 18 manettes, tirées avec une graine fixe pour que le fond soit identique sur chaque
 * écran. Chaque manette est soit un des modèles dessinés en pixels (sprites.js), soit une image de la galerie ajoutée
 * par le personnel. Les tirages sont toujours les mêmes quel que soit le nombre d'images : en ajouter ou en retirer ne
 * déplace pas les autres manettes.
 */

export const NB_MANETTES = 18;

/** Hauteur, en pixels d'écran, d'une image de la galerie (proche, lointaine) : largeur automatique. */
export const HAUTEUR_IMAGE = {proche: 40, lointaine: 28};

// jeux de couleurs du corps des manettes dessinées : [normal, clair, ombré]
export const COULEURS = [
    ["#3cb371", "#7be0a2", "#25804f"],   // vert AkitaTek
    ["#e0457b", "#f58aaf", "#a02a58"],   // rose
    ["#4f8ff7", "#8ab8ff", "#2f63b8"],   // bleu
    ["#f2b632", "#ffd978", "#b88411"],   // jaune
    ["#9b6bff", "#c3a4ff", "#6a3fc9"],   // violet
    ["#c7ccd6", "#eef0f5", "#8a91a0"],   // gris clair
];

/** Générateur pseudo-aléatoire à graine (mulberry32) : mêmes manettes à chaque fois. */
export function aleatoire(graine) {
    return () => {
        graine = (graine + 0x6D2B79F5) | 0;
        let t = Math.imul(graine ^ (graine >>> 15), 1 | graine);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

/**
 * @param nbImages nombre d'images de la galerie disponibles
 * @param nombre   nombre de manettes à afficher (réglage du tableau de bord, 18 par défaut) : les premières manettes ne changent
 *                 pas quand on en ajoute ou retire, car chaque tirage suit toujours le même ordre
 * @returns les manettes : {type: "sprite" | "image", modele, indexImage, echelle, hauteur, haut, couleurs, opacite, duree, decalage, repos}
 *   - une image est choisie avec la probabilité nbImages / (nbImages + 2) : chaque image pèse autant qu'un modèle dessiné
 *   - indexImage : rang de l'image (à ramener au nombre d'images avec un modulo)
 */
export function construire(nbImages, nombre = NB_MANETTES) {
    const hasard = aleatoire(7102026);
    return Array.from({length: nombre}, (_, i) => {
        const proche = i % NB_MANETTES >= 11;                   // sur chaque série de 18 : 7 manettes proches, 11 lointaines
        const tirageType = hasard();
        const modele = hasard() < 0.6 ? "moderne" : "retro";
        const indexImage = Math.floor(hasard() * 1000);
        const echelle = proche ? 3 : 2;                         // taille d'un pixel des manettes dessinées, en pixels d'écran
        const image = nbImages > 0 && tirageType < nbImages / (nbImages + 2);
        const hauteur = image ? HAUTEUR_IMAGE[proche ? "proche" : "lointaine"] : SPRITES[modele].hauteur * echelle;
        const duree = proche ? 20 + hasard() * 8 : 32 + hasard() * 12;   // secondes pour traverser (2 largeurs de bandeau)
        const haut = Math.round(2 + hasard() * (110 - hauteur - 2));
        const couleurs = COULEURS[Math.floor(hasard() * COULEURS.length)];
        const delai = hasard() * duree;
        return {
            type: image ? "image" : "sprite",
            modele,
            indexImage,
            echelle,
            hauteur,
            haut,
            couleurs,
            opacite: proche ? 0.95 : 0.55,
            duree,                                              // secondes pour traverser, à la vitesse d'origine
            decalage: delai / duree,                            // part de la durée déjà écoulée à l'ouverture de la page
            repos: Math.round(4 + (i / nombre) * 78) + "%",    // position fixe si les animations sont réduites
        };
    });
}
